import { useExperienceMasterDataApi } from "@/composables/useExperienceMasterDataApi";
import { useQuery } from "@tanstack/vue-query";

export function useIncludedMasterdataQuery() {
  const experienceMasterDataApi = useExperienceMasterDataApi();
  return useQuery({
    queryKey: ["included-masterdata"],
    queryFn: () => experienceMasterDataApi.getPremades("included", { language_code: "en" }),
    select: ({ data }) => data,
  });
}
